import React from 'react'
import './services.css'
import {BiCheck} from 'react-icons/bi'


const Services = () => {
    return (
        <section id="services">
            <h5>What I Offer</h5>
            <h2>Services</h2>
            <div className="container services__container">
                <article className="service">
                    <div className="service__head">
                        <h3>COUPLE PHOTOGRAPHY</h3>
                    </div>
                    <ul className="service__list">
                        <li>
                            <p>The first moments of a couple in love are truly unique! Excitement, 
                                bouquets of hugs and kisses, euphoric energy, and passionate attraction 
                                to each other. A romantic loveshoot captures the very warmth of your 
                                gorgeous couple in natural portraiture, allowing you to return to these 
                                beautiful moments over and over again.</p>
                        </li>
                    </ul>
                </article>
                <article className="service">
                    <div className="service__head">
                        <h3>PORTRAIT PHOTOGRAPHY</h3>
                    </div>
                    <ul className="service__list">
                        <li>
                            <p>Unleash your individuality with your solo photoshoot. 
                                It's your time to shine and express yourself creatively. 
                                Together, we'll craft captivating portraits that reflect 
                                your unique story and inner beauty. Let's turn your vision 
                                into stunning imagery that you'll cherish for a lifetime.</p>
                        </li>
                    </ul>
                </article>
                <article className="service">
                    <div className="service__head">
                        <h3>PROJECT PHOTOGRAPHY</h3>
                    </div>
                    <ul className="service__list">
                        <li>
                            <p>Specializing in food projects, I capture the flavors, textures, and artistry of 
                                each dish with precision. For beauty salons, I highlight the elegance of hairstyles,
                                makeup, and ambiance, crafting captivating visuals. With a collaborative approach,
                                I strive to exceed expectations, portraying each project's essence and allure. Whether
                                it's tantalizing food spreads or serene salon settings, I am committed to delivering 
                                stunning imagery that elevates your brand. Contact me to bring your culinary creations 
                                and salon ambiance to life through captivating photography.</p>
                        </li>
                    </ul>
                </article>
            </div>
        </section>
    )
}
export default Services
